var map = {
	"./AskKural.svg": 91639,
	"./Kural.svg": 2626,
	"./PXB.svg": 82805,
	"./ZS.svg": 60118
};



function webpackAsyncContext(req) {
	return webpackAsyncContextResolve(req).then((id) => (__webpack_require__.t(id, 1 | 16)));
}
function webpackAsyncContextResolve(req) {
	return __webpack_require__.e(/* lazy-once context | favicon */ 109).then(() => {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.resolve = webpackAsyncContextResolve;
webpackAsyncContext.id = 61344;
module.exports = webpackAsyncContext;